/* kesser-cache-bust:20260917144953 */
(function () {
  // Dia do Cliente 2026 — presentes por faixa (NÃO cumulativo).
  // Janela: 14/09/2026 12:00 → EARLY END 17/09/2026 14:40 America/Sao_Paulo (promo paused)
  const CAMPAIGN_START_MS = Date.parse('2026-09-14T12:00:00-03:00');
  const CAMPAIGN_END_MS = Date.parse('2026-09-17T14:40:00.000-03:00');

  // Gift-only SKUs (unpublished). Paid sellable variants stay full price.
  // Bálsamo gift 54078835982633 | All Clean gift 54078836015401 | Travel gift 54078836048169
  // Exclusive (non-cumulative) tiers — exactly ONE match; maxCents is exclusive upper bound.
  // ≥650: Bálsamo+Gel | ≥400&<650: Bálsamo only | ≥250&<400: Travel only | <250: none
  const TIERS = [
    {
      minCents: 65000,
      maxCents: Infinity,
      label: 'Dia do Cliente — R$ 650+',
      variants: [54078835982633, 54078836015401], // BRINDE Bálsamo + BRINDE Gel/All Clean
    },
    {
      minCents: 40000,
      maxCents: 65000,
      label: 'Dia do Cliente — R$ 400+',
      variants: [54078835982633], // BRINDE Bálsamo ONLY (no Travel, no Gel)
    },
    {
      minCents: 25000,
      maxCents: 40000,
      label: 'Dia do Cliente — R$ 250+',
      variants: [54078836048169], // BRINDE Travel ONLY (no Bálsamo, no Gel)
    },
  ];

  const ALL_GIFT_VARIANT_IDS = new Set(TIERS.flatMap((t) => t.variants));
  const GIFT_PROPERTY = '_kesser_auto_gift';
  const TIER_PROPERTY = '_kesser_gift_tier';
  const SYNC_DEBOUNCE_MS = 0;
  const SYNC_SAFETY_MS = 5000;
  const CHECKOUT_GATE_TIMEOUT_MS = 4000;

  let lastSignature = '';
  let syncing = false;
  let syncSafetyTimer = null;
  let syncQueue = Promise.resolve();
  let internalCartCallDepth = 0;
  let suppressCartEventSync = false;
  let debounceTimer = null;
  let pendingCartHint = null;
  let suppressThemeNotify = false;
  const giftUnavailable = {};

  function nowMs() {
    return Date.now();
  }

  function isPreviewDiaDoClienteTheme() {
    try {
      const themeId = Number(
        (window.Shopify && Shopify.theme && Shopify.theme.id) ||
          (window.KESSER_THEME_ID || 0)
      );
      if (themeId === 183969251625) return true;
    } catch (e) {}
    try {
      const q = new URLSearchParams(window.location.search);
      if (q.get('preview_theme_id') === '183969251625') return true;
    } catch (e) {}
    return false;
  }

  function campaignActive() {
    // Early deactivation 2026-09-17 ~14:40 SP — preview force-open DISABLED.
    // endsAt in the past => false for any clock at/after end.
    const n = nowMs();
    return n >= CAMPAIGN_START_MS && n <= CAMPAIGN_END_MS;
  }

  function injectStyles() {
    if (document.getElementById('kesser-auto-gift-styles')) return;
    const style = document.createElement('style');
    style.id = 'kesser-auto-gift-styles';
    style.textContent = `
      .kesser-auto-gift-line quantity-input .quantity__button,
      .kesser-auto-gift-line .quantity__button {
        display: none !important;
        pointer-events: none !important;
      }
      .kesser-auto-gift-line .quantity__input {
        pointer-events: none !important;
        opacity: 0.65;
        border: 0;
        background: transparent;
        text-align: center;
        max-width: 2.5rem;
      }
      .kesser-auto-gift-line cart-remove-button,
      .kesser-auto-gift-line .cart-remove-button,
      .kesser-auto-gift-line a[href*="quantity=0"] {
        display: none !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  function isInternalCartCall() {
    return internalCartCallDepth > 0;
  }

  async function cartFetch(url, options) {
    internalCartCallDepth += 1;
    try {
      return await fetch(url, options);
    } finally {
      internalCartCallDepth -= 1;
    }
  }

  function normalizeProperties(properties) {
    if (!properties) return {};
    if (Array.isArray(properties)) {
      return properties.reduce((acc, entry) => {
        const name = entry?.name ?? entry?.first ?? entry?.key;
        const value = entry?.value ?? entry?.last ?? '';
        if (name) acc[name] = value;
        return acc;
      }, {});
    }
    return { ...properties };
  }

  function isGiftVariant(variantId) {
    return ALL_GIFT_VARIANT_IDS.has(Number(variantId));
  }

  function isAutoGiftLine(item) {
    // Lines WE marked as campaign gift (property). Legacy paid-SKU gift lines
    // with the mark are included so sync can remove/replace them.
    if (!item) return false;
    const props = normalizeProperties(item.properties);
    return String(props[GIFT_PROPERTY]) === '1';
  }

  function isCampaignGiftLine(item) {
    // Gift-only SKUs must NEVER linger alongside another tier's gifts.
    // Treat marked gifts AND any line whose variant is a gift-only SKU as removable.
    if (!item) return false;
    if (isAutoGiftLine(item)) return true;
    return isGiftVariant(item.variant_id);
  }

  function findAutoGiftLines(cart) {
    return (cart.items || []).filter(isAutoGiftLine);
  }

  function findCampaignGiftLines(cart) {
    return (cart.items || []).filter(isCampaignGiftLine);
  }

  function getSectionsConfig() {
    // Empty on purpose: theme.js owns the cart drawer DOM (Brinde badge, locks).
    // Replacing .cart-drawer__panel with Liquid HTML was wiping those UI tweaks.
    return [];
  }

  function getSectionKeys() {
    return getSectionsConfig().map((section) => section.key);
  }

  function getSubtotalExcludingAutoGift(cart) {
    // Post-discount paid amount (after coupons). Gift tiers ≥250/≥400/≥650 must
    // use value AFTER any discount — if a coupon drops below a tier, remove that gift.
    // Preferred: cart.total_price − gift lines' final_line_price (R$0 gifts → payable).
    // Do NOT use pre-discount original_line_price for tier selection.
    const giftFinal = (cart.items || []).reduce((sum, item) => {
      if (!isCampaignGiftLine(item)) return sum;
      return sum + Number(item.final_line_price || 0);
    }, 0);
    return Math.max(0, Number(cart.total_price || 0) - giftFinal);
  }

  function selectTier(subtotalCents) {
    // Exactly one exclusive tier (min inclusive, max exclusive). Order-independent.
    const n = Number(subtotalCents) || 0;
    for (const t of TIERS) {
      const max = t.maxCents == null ? Infinity : t.maxCents;
      if (n >= t.minCents && n < max) return t;
    }
    return null;
  }

  function buildSignature(cart) {
    const itemsSig = cart.items
      .map((item) => `${item.key}:${item.variant_id}:${item.quantity}:${item.final_line_price}`)
      .sort()
      .join('|');
    return `${itemsSig}|${cart.total_price}|${campaignActive() ? 'on' : 'off'}`;
  }

  function desiredVariantSet(tier) {
    return new Set((tier?.variants || []).map(Number));
  }

  function giftIsValid(cart) {
    const autoGifts = findCampaignGiftLines(cart);
    if (!campaignActive()) return autoGifts.length === 0;

    const subtotal = getSubtotalExcludingAutoGift(cart);
    const tier = selectTier(subtotal);
    if (!tier) return autoGifts.length === 0;

    const desired = desiredVariantSet(tier);
    const present = new Map();
    for (const line of autoGifts) {
      const id = Number(line.variant_id);
      present.set(id, (present.get(id) || 0) + Number(line.quantity || 0));
    }

    // Exact desired set only — never allow gifts from another tier (e.g. Travel+Bálsamo).
    for (const id of desired) {
      if (giftUnavailable[id] && !present.has(id)) continue;
      if (present.get(id) === 1) continue;
      return false;
    }
    for (const [id, qty] of present.entries()) {
      if (!desired.has(id) || qty !== 1) return false;
    }
    // Harden: present keys must equal desired (minus unavailable missing).
    if (present.size > desired.size) return false;
    return true;
  }

  function checkoutShouldEnable(cart) {
    if (!cart?.items?.length) return false;
    const nonGiftItems = cart.items.filter((item) => !isAutoGiftLine(item));
    if (!nonGiftItems.length) return false;

    const autoGifts = findCampaignGiftLines(cart);
    if (!campaignActive()) return autoGifts.length === 0;

    const subtotal = getSubtotalExcludingAutoGift(cart);
    const tier = selectTier(subtotal);
    if (!tier) return autoGifts.length === 0;

    return giftIsValid(cart);
  }

  async function fetchCart() {
    const response = await cartFetch('/cart.js', { cache: 'no-store' });
    return response.json();
  }

  function parseSectionHTML(html, selector) {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const scoped = doc.querySelector(selector);
    if (scoped) return scoped.innerHTML;
    const section = doc.querySelector('.shopify-section');
    return section ? section.innerHTML : html;
  }

  function notifyThemeCartRefresh() {
    // theme.js owns the drawer DOM. Gift sync uses internal fetch, so we must
    // ask the drawer to re-render without re-entering gift sync.
    suppressCartEventSync = true;
    try {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      suppressCartEventSync = false;
    }
  }

  function applySections(sections) {
    if (!sections) return;
    getSectionsConfig().forEach(({ key, selector }) => {
      const html = sections[key];
      if (!html) return;
      const target = document.querySelector(selector);
      if (target) target.innerHTML = parseSectionHTML(html, selector.split(' ').pop());
    });
    notifyThemeCartRefresh();
    requestAnimationFrame(() => lockGiftUI());
  }

  async function refreshCartUI() {
    const sections = getSectionKeys();
    if (!sections.length) return null;
    const response = await cartFetch(`/cart/update.js?sections=${sections.join(',')}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });
    const data = await response.json();
    applySections(data.sections);
    return data;
  }

  function setCheckoutDisabled(disabled, reason = '') {
    document
      .querySelectorAll(
        'button[name="checkout"], a[href="/checkout"], .cart__checkout-button, .drawer__checkout, #CartDrawer-Checkout'
      )
      .forEach((button) => {
        if (disabled) {
          button.setAttribute('disabled', 'disabled');
          button.setAttribute('aria-disabled', 'true');
          button.style.cursor = 'not-allowed';
          button.style.opacity = '0.5';
          button.title = reason;
        } else {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
          button.style.cursor = '';
          button.style.opacity = '';
          button.title = '';
        }
      });
  }

  function updateCheckoutState(cart) {
    if (syncing) {
      setCheckoutDisabled(true, 'Atualizando brinde...');
      return;
    }
    const onlyAutoGift = cart.items.length > 0 && cart.items.every(isCampaignGiftLine);
    if (onlyAutoGift) {
      setCheckoutDisabled(true, 'Adicione produtos para finalizar a compra.');
      return;
    }
    if (!giftIsValid(cart)) {
      setCheckoutDisabled(true, 'Ajustando brindes...');
      return;
    }
    setCheckoutDisabled(!checkoutShouldEnable(cart), '');
  }

  function clearSyncSafetyTimer() {
    if (syncSafetyTimer) {
      clearTimeout(syncSafetyTimer);
      syncSafetyTimer = null;
    }
  }

  function armSyncSafetyTimer() {
    clearSyncSafetyTimer();
    // Do NOT clear `syncing` here — that allowed a second syncGift to run in
    // parallel (Travel add + Bálsamo add) and leave gifts from two tiers in cart.
    syncSafetyTimer = setTimeout(() => {
      if (!syncing) return;
      fetchCart()
        .then((cart) => updateCheckoutState(cart))
        .catch(() => setCheckoutDisabled(false));
    }, SYNC_SAFETY_MS);
  }

  function finishSync(cart) {
    syncing = false;
    clearSyncSafetyTimer();
    const done = (fresh) => {
      updateCheckoutState(fresh);
      lockGiftUI(fresh);
      // Theme pipeline awaits ensureReady and renders once — avoid double redraw stutter.
      if (!suppressThemeNotify) notifyThemeCartRefresh();
    };
    if (cart) {
      done(cart);
      return;
    }
    fetchCart()
      .then(done)
      .catch(() => setCheckoutDisabled(false));
  }

  function unlockGiftRows() {
    document.querySelectorAll('.kesser-auto-gift-line').forEach((row) => {
      row.classList.remove('kesser-auto-gift-line');
    });
  }

  function lockGiftUI(cartHint) {
    unlockGiftRows();
    const applyLock = (cart) => {
      cart.items.forEach((item, index) => {
        if (!isCampaignGiftLine(item)) return;
        const lineNumber = index + 1;
        const row =
          document.getElementById(`CartDrawer-Item-${lineNumber}`) ||
          document.getElementById(`CartItem-${lineNumber}`);
        if (!row) return;
        row.classList.add('kesser-auto-gift-line');
        row.querySelectorAll('.quantity__input').forEach((input) => {
          input.readOnly = true;
          input.disabled = true;
          input.setAttribute('aria-disabled', 'true');
        });
        row.querySelectorAll('quantity-input .quantity__button, .quantity__button').forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-hidden', 'true');
        });
      });
    };
    if (cartHint?.items) {
      applyLock(cartHint);
      return;
    }
    fetchCart().then(applyLock).catch(() => {});
  }

  async function addGiftVariant(variantId, tierLabel) {
    const sections = getSectionKeys();
    const payload = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            [GIFT_PROPERTY]: '1',
            [TIER_PROPERTY]: tierLabel,
            Brinde: tierLabel,
          },
        },
      ],
    };
    if (sections.length) {
      payload.sections = sections.join(',');
      payload.sections_url = window.location.pathname;
    }
    const response = await cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(data?.description || data?.message || 'Kesser gift add failed');
      error.data = data;
      throw error;
    }
    if (data.sections) applySections(data.sections);
    return data;
  }

  async function changeCartLine(lineKey, quantity) {
    const response = await cartFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity,
        sections: getSectionKeys().join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (data.sections) applySections(data.sections);
    else await refreshCartUI();
    return data;
  }


  async function mergeDuplicatePaidLines(cart) {
    // Collapse identical paid SKUs into one line. Gift lines (_kesser_auto_gift)
    // stay separate and are never merged with paid units of the same variant.
    if (!cart || !cart.items || cart.items.length < 2) return cart;
    const groups = new Map();
    for (const item of cart.items) {
      if (isCampaignGiftLine(item)) continue;
      const sig = String(item.variant_id);
      if (!groups.has(sig)) groups.set(sig, []);
      groups.get(sig).push(item);
    }
    const updates = {};
    let need = false;
    for (const lines of groups.values()) {
      if (lines.length < 2) continue;
      need = true;
      const total = lines.reduce((s, l) => s + Number(l.quantity || 0), 0);
      updates[lines[0].key] = total;
      for (let i = 1; i < lines.length; i += 1) updates[lines[i].key] = 0;
    }
    if (!need) return cart;
    const response = await cartFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    const data = await response.json();
    if (data.sections) applySections(data.sections);
    return data.items ? data : fetchCart();
  }

  async function removeGiftKeys(keys) {
    if (!keys.length) return null;
    const updates = {};
    for (const key of keys) updates[key] = 0;
    const response = await cartFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    const data = await response.json();
    if (data.sections) applySections(data.sections);
    return data.items ? data : fetchCart();
  }

  async function removeNonDesiredGifts(cart, desired) {
    const keys = findCampaignGiftLines(cart)
      .filter((line) => !desired.has(Number(line.variant_id)))
      .map((line) => line.key);
    if (!keys.length) return cart;
    return removeGiftKeys(keys);
  }

  async function syncGift(cart) {
    // Always re-read cart so tier uses post-coupon total_price (never stale add.js hint).
    cart = cart?.items ? cart : await fetchCart();
    cart = await fetchCart();

    if (!campaignActive()) {
      const keys = findCampaignGiftLines(cart).map((l) => l.key);
      if (keys.length) cart = await removeGiftKeys(keys);
      Object.keys(giftUnavailable).forEach((k) => delete giftUnavailable[k]);
      return mergeDuplicatePaidLines(cart);
    }

    const subtotal = getSubtotalExcludingAutoGift(cart);
    const tier = selectTier(subtotal);
    const desired = desiredVariantSet(tier);

    // Exclusive: strip EVERY gift not in this tier (Travel when ≥400, Bálsamo when only ≥250, etc.).
    cart = await removeNonDesiredGifts(cart, desired);

    if (!tier) {
      // <250 — ensure zero gifts remain
      cart = await removeNonDesiredGifts(await fetchCart(), new Set());
      return mergeDuplicatePaidLines(cart);
    }

    // Deduplicate / fix qty for desired gifts.
    cart = await fetchCart();
    const byVariant = new Map();
    for (const line of findCampaignGiftLines(cart)) {
      const id = Number(line.variant_id);
      if (!desired.has(id)) continue;
      if (!byVariant.has(id)) byVariant.set(id, []);
      byVariant.get(id).push(line);
    }

    const dedupeKeys = [];
    for (const [, lines] of byVariant.entries()) {
      for (let i = 1; i < lines.length; i += 1) dedupeKeys.push(lines[i].key);
    }
    if (dedupeKeys.length) cart = await removeGiftKeys(dedupeKeys);

    for (const id of desired) {
      cart = await fetchCart();
      const keep = findCampaignGiftLines(cart).find((l) => Number(l.variant_id) === id);
      if (keep && keep.quantity !== 1) {
        await changeCartLine(keep.key, 1);
      }
    }

    cart = await fetchCart();
    for (const variantId of tier.variants) {
      const id = Number(variantId);
      const presentAsGift = findCampaignGiftLines(cart).some((l) => Number(l.variant_id) === id);
      if (presentAsGift) {
        delete giftUnavailable[id];
        continue;
      }
      try {
        await addGiftVariant(id, tier.label);
        delete giftUnavailable[id];
        cart = await fetchCart();
      } catch (error) {
        console.warn('Kesser gift: could not add', id, error);
        giftUnavailable[id] = true;
      }
    }

    // Final exclusivity pass — never leave gifts from multiple tiers.
    cart = await fetchCart();
    cart = await removeNonDesiredGifts(cart, desired);
    cart = await fetchCart();
    if (!giftIsValid(cart)) {
      // One more strip of anything outside desired, then stop (missing = unavailable).
      cart = await removeNonDesiredGifts(cart, desired);
      cart = await fetchCart();
    }

    return mergeDuplicatePaidLines(cart);
  }

  function runSync(cartHint) {
    // Queue serializes all syncs. Never skip a queued run (old `if (syncing) return`
    // dropped coupon re-evals and left Travel+Bálsamo together).
    syncQueue = syncQueue
      .then(async () => {
        syncing = true;
        armSyncSafetyTimer();
        let cart = null;
        try {
          // Ignore stale cartHint totals — coupon/GABI must be read from /cart.js.
          void cartHint;
          cart = await fetchCart();
          const signature = buildSignature(cart);
          const needsSync = signature !== lastSignature || !giftIsValid(cart);
          if (needsSync) {
            cart = await syncGift(cart);
          } else {
            cart = await mergeDuplicatePaidLines(cart);
          }
          // Hard assert: if multiple tiers' gifts somehow remain, force another syncGift.
          if (!giftIsValid(cart)) {
            cart = await syncGift(await fetchCart());
          }
          lastSignature = buildSignature(cart);
        } catch (error) {
          console.error('Kesser gift sync error:', error);
          try {
            cart = await fetchCart();
          } catch {
            cart = null;
          }
        } finally {
          finishSync(cart);
        }
      })
      .catch(() => {
        finishSync(null);
      });
    return syncQueue;
  }

  function enqueueSync(cartHint) {
    if (cartHint?.items) pendingCartHint = cartHint;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const hint = pendingCartHint;
      pendingCartHint = null;
      runSync(hint);
    }, SYNC_DEBOUNCE_MS);
  }

  async function ensureGiftReady() {
    suppressThemeNotify = true;
    try {
      await runSync();
      let cart = await fetchCart();
      cart = await mergeDuplicatePaidLines(cart);
      return cart;
    } finally {
      suppressThemeNotify = false;
    }
  }

  // Public API for theme.js drawer — one sync, then one paint.
  window.KesserGifts = {
    ensureReady: ensureGiftReady,
    syncNow: runSync,
    mergePaidLines: mergeDuplicatePaidLines,
    giftIsValid,
    checkoutShouldEnable,
  };

  function hookFetch() {
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
        if (isInternalCartCall() || suppressCartEventSync) return response;
        response
          .clone()
          .json()
          .then((data) => enqueueSync(data.items ? data : null))
          .catch(() => enqueueSync());
      }
      return response;
    };
  }

  const CHECKOUT_SELECTOR =
    'button[name="checkout"], a[href="/checkout"], .cart__checkout-button, .drawer__checkout, #CartDrawer-Checkout';
  let checkoutGateInFlight = false;
  let allowNativeCheckoutOnce = false;

  function showAdjustingGiftsMessage(visible) {
    let el = document.getElementById('kesser-gift-adjust-msg');
    if (!visible) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = 'kesser-gift-adjust-msg';
    }
    el.setAttribute('role', 'status');
    el.style.cssText =
      'margin:0.75rem 0;padding:0.65rem 0.85rem;border-radius:8px;background:#fff7ed;border:1px solid #fdba74;color:#9a3412;font-size:0.9rem;font-weight:600;text-align:center;';
    el.textContent = 'Ajustando brindes...';
    const anchors = document.querySelectorAll(
      '.cart__ctas, .drawer__footer, .cart-drawer__footer, #CartDrawer-Checkout, button[name="checkout"]'
    );
    let placed = false;
    anchors.forEach((node) => {
      if (placed) return;
      const parent = node.closest('.cart__ctas, .drawer__footer, .cart-drawer__footer') || node.parentElement;
      if (!parent) return;
      if (!parent.contains(el)) parent.insertBefore(el, parent.firstChild);
      placed = true;
    });
    if (!placed && document.body && !document.getElementById('kesser-gift-adjust-msg')) {
      document.body.appendChild(el);
    }
  }

  function withTimeout(promise, ms, label) {
    let timer = null;
    const timeout = new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error(label || 'timeout')), ms);
    });
    return Promise.race([promise, timeout]).finally(() => {
      if (timer) clearTimeout(timer);
    });
  }

  function showGiftGateError(message) {
    let el = document.getElementById('kesser-gift-adjust-msg');
    if (!el) {
      el = document.createElement('div');
      el.id = 'kesser-gift-adjust-msg';
      el.setAttribute('role', 'alert');
      el.style.cssText =
        'margin:0.75rem 0;padding:0.65rem 0.85rem;border-radius:8px;background:#fef2f2;border:1px solid #fca5a5;color:#991b1b;font-size:0.9rem;font-weight:600;text-align:center;';
    } else {
      el.setAttribute('role', 'alert');
      el.style.background = '#fef2f2';
      el.style.border = '1px solid #fca5a5';
      el.style.color = '#991b1b';
    }
    el.textContent = message || 'Não foi possível ajustar os brindes. Tente novamente.';
    const anchors = document.querySelectorAll(
      '.cart__ctas, .drawer__footer, .cart-drawer__footer, #CartDrawer-Checkout, button[name="checkout"]'
    );
    let placed = false;
    anchors.forEach((node) => {
      if (placed) return;
      const parent = node.closest('.cart__ctas, .drawer__footer, .cart-drawer__footer') || node.parentElement;
      if (!parent) return;
      if (!parent.contains(el)) parent.insertBefore(el, parent.firstChild);
      placed = true;
    });
    if (!placed && document.body && !document.getElementById('kesser-gift-adjust-msg')) {
      document.body.appendChild(el);
    }
  }

  function failClosedGiftGate(cart, reason) {
    console.warn('Kesser checkout gift gate: fail-closed', reason);
    showGiftGateError('Não foi possível ajustar os brindes. Tente novamente.');
    // Keep button usable so customer can retry. Do NOT call updateCheckoutState here —
    // it would re-disable while gifts are still invalid. Never proceed with wrong gifts.
    setCheckoutDisabled(false, 'Não foi possível ajustar os brindes. Tente novamente.');
    return { ok: false, cart, reason: reason || 'invalid-gifts' };
  }

  async function hardenGiftsBeforeCheckout() {
    // Eye Patch promo gate removed 2026-10-20 (promo ended 20/10 12:00 SP); never block checkout for it.
    // Fast path: inactive campaign with no gift lines — never block checkout.
    try {
      const quick = await fetchCart();
      if (!campaignActive() && findCampaignGiftLines(quick).length === 0) {
        showAdjustingGiftsMessage(false);
        setCheckoutDisabled(false);
        return { ok: true, cart: quick, reason: 'campaign-off' };
      }
      // Fast path: gifts already match tier (e.g. 2x All Protect + Travel) — proceed immediately.
      if (giftIsValid(quick) && checkoutShouldEnable(quick)) {
        showAdjustingGiftsMessage(false);
        setCheckoutDisabled(false);
        return { ok: true, cart: quick, reason: 'already-valid' };
      }
    } catch (e) {
      /* fall through to timed sync */
    }
    setCheckoutDisabled(true, 'Adicionando seu brinde...');
    showAdjustingGiftsMessage(true);

    // Force full sync (ignore lastSignature) so checkout never uses a stale tier.
    lastSignature = '';
    let cart = null;
    try {
      cart = await withTimeout(ensureGiftReady(), CHECKOUT_GATE_TIMEOUT_MS - 500, 'gift-ready-timeout');
    } catch (e) {
      console.warn('Kesser checkout gift gate: sync timeout/error', e);
      cart = await fetchCart().catch(() => null);
    }

    if (cart && !giftIsValid(cart)) {
      // One nuclear strip + resync, still within remaining budget — then FAIL CLOSED if still bad.
      try {
        const keys = findCampaignGiftLines(await fetchCart()).map((l) => l.key);
        if (keys.length) await removeGiftKeys(keys);
        lastSignature = '';
        cart = await withTimeout(ensureGiftReady(), 1500, 'gift-resync-timeout');
      } catch (e) {
        console.warn('Kesser checkout gift gate: resync failed', e);
        cart = await fetchCart().catch(() => cart);
      }
    }

    if (cart) updateCheckoutState(cart);

    // FAIL CLOSED: never strip-and-proceed, never checkout with wrong gifts.
    if (cart && giftIsValid(cart) && checkoutShouldEnable(cart)) {
      showAdjustingGiftsMessage(false);
      setCheckoutDisabled(false);
      return { ok: true, cart, reason: 'synced' };
    }

    return failClosedGiftGate(cart, 'invalid-after-sync');
  }

  function checkoutUrl() {
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (root && root !== '/') {
        return root.replace(/\/?$/, '/') + 'checkout';
      }
    } catch (e) {}
    return '/checkout';
  }

  function proceedToCheckout(_checkout) {
    // CRITICAL: never HTMLFormElement.prototype.submit() without submitter name=checkout —
    // Shopify treats bare form.submit() as cart UPDATE and stays on /cart forever.
    allowNativeCheckoutOnce = true;
    showAdjustingGiftsMessage(false);
    setCheckoutDisabled(false);
    window.location.assign(checkoutUrl());
  }

  function hookCheckout() {
    document.addEventListener(
      'click',
      async (event) => {
        const checkout = event.target.closest(CHECKOUT_SELECTOR);
        if (!checkout) return;
        if (allowNativeCheckoutOnce) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        if (checkoutGateInFlight) return;
        checkoutGateInFlight = true;
        try {
          const result = await withTimeout(
            hardenGiftsBeforeCheckout(),
            CHECKOUT_GATE_TIMEOUT_MS + 11000, // + Eye Patch gift wait (up to 10s)
            'checkout-gate-timeout'
          );
          if (result && result.ok) {
            proceedToCheckout(checkout);
          }
          // else fail-closed already re-enabled button + showed message
        } catch (error) {
          console.error('Kesser checkout gift gate: timeout/error — fail-closed', error);
          let cart = null;
          try {
            cart = await fetchCart();
          } catch (e) {}
          if (cart && giftIsValid(cart) && checkoutShouldEnable(cart)) {
            proceedToCheckout(checkout);
          } else {
            failClosedGiftGate(cart, 'gate-timeout');
          }
        } finally {
          checkoutGateInFlight = false;
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (allowNativeCheckoutOnce) return;
        const hasCheckout =
          form.querySelector(CHECKOUT_SELECTOR) ||
          ((form.getAttribute('action') || '').includes('/cart') &&
            form.querySelector('button[name="checkout"], input[name="checkout"]'));
        if (!hasCheckout) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        if (checkoutGateInFlight) return;
        checkoutGateInFlight = true;
        const target =
          form.querySelector(CHECKOUT_SELECTOR) || form.querySelector('button[name="checkout"]');
        try {
          const result = await withTimeout(
            hardenGiftsBeforeCheckout(),
            CHECKOUT_GATE_TIMEOUT_MS + 11000, // + Eye Patch gift wait (up to 10s)
            'checkout-gate-timeout'
          );
          if (result && result.ok) {
            proceedToCheckout(target);
          }
        } catch (error) {
          console.error('Kesser checkout gift gate (submit): timeout/error — fail-closed', error);
          let cart = null;
          try {
            cart = await fetchCart();
          } catch (e) {}
          if (cart && giftIsValid(cart) && checkoutShouldEnable(cart)) {
            proceedToCheckout(target);
          } else {
            failClosedGiftGate(cart, 'gate-timeout-submit');
          }
        } finally {
          checkoutGateInFlight = false;
        }
      },
      true
    );
  }

  function hookCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const observer = new MutationObserver(() => {
      if (drawer.hasAttribute('open')) enqueueSync();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  function hookPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (isInternalCartCall() || suppressCartEventSync) return;
      enqueueSync();
    });
  }

  function isCartPage() {
    return window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart');
  }

  async function bootstrapCartPage() {
    await runSync();
    const cart = await fetchCart().catch(() => null);
    if (cart) updateCheckoutState(cart);
  }

  function isCartDrawerOpen() {
    const drawer = document.getElementById('CartDrawer');
    return !!(drawer && drawer.hasAttribute('open'));
  }

  async function assertGiftsIfVisible() {
    if (!isCartDrawerOpen() && !isCartPage()) return;
    try {
      const cart = await fetchCart();
      if (!giftIsValid(cart)) {
        setCheckoutDisabled(true, 'Ajustando brindes...');
        showAdjustingGiftsMessage(true);
        await runSync(cart);
        const fresh = await fetchCart();
        updateCheckoutState(fresh);
        if (giftIsValid(fresh) && checkoutShouldEnable(fresh)) {
          showAdjustingGiftsMessage(false);
        }
      }
    } catch (e) {
      /* ignore transient cart.js errors */
    }
  }

  function start() {
    injectStyles();
    hookFetch();
    hookCheckout();
    hookCartDrawer();
    hookPubSub();
    if (isCartPage()) bootstrapCartPage();
    else enqueueSync();
    document.addEventListener('cart:updated', () => {
      if (suppressCartEventSync || isInternalCartCall()) return;
      enqueueSync();
    });
    document.addEventListener('cart:refresh', () => lockGiftUI());
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        enqueueSync();
        assertGiftsIfVisible();
      }
    });
    // Background sync + hard assert while drawer open or on /cart
    setInterval(() => enqueueSync(), 8000);
    setInterval(() => {
      assertGiftsIfVisible();
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
